// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-outline-primary {
    color: #358696;
    border-color: #358696;
}

.btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:visited,
.btn-outline-primary:active,
.btn-check:checked+.btn,
.btn.active,
.btn.show,
.btn:first-child:active,
:not(.btn-check)+.btn:active {
    background-color: #358696;
    color: #fff;
}

.btn:hover {
    color: var(--bs-btn-hover-color);
    background-color: #358696;
    border-color: #358696;
}

.btn-primary {
    --bs-btn-color: #fff;
    --bs-btn-bg: #358696;
    --bs-btn-border-color: #358696;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #358696;
    --bs-btn-hover-border-color: #358696;
    --bs-btn-focus-shadow-rgb: 49, 132, 253;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #358696;
    --bs-btn-active-border-color: #358696;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #358696;
    --bs-btn-disabled-border-color: #358696;
}

.form-check-input:checked {
    background-color: #358696;
    border-color: #358696;
}

.form-select:focus {
    border-color: #358696;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 23%);
}

/* Tabs Section */
.nav-link:focus,
.nav-link:hover {
    /* color: var(--bs-nav-link-hover-color); */
    color: #358696;
}

.nav-link {
    color: #999;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
    color: #358696;
    background-color: var(--bs-nav-tabs-link-active-bg);
    border-color: var(--bs-nav-tabs-link-active-border-color);
}

/* Section Header<> */

.secHead34 {
    background-color: #d3eff4;
    padding: 10px;
    margin-bottom: 20px;
}

.bg-white {
    background-color: #fff;
}

.headBG {
    box-sizing: border-box;
    background: #FFFFFF;
    border: 1px solid #358696;
}

.mainDiv {
    margin-top: 80px;
}

.widget_bus {
    background: #CDDAEA;
    box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
}

.widgetIcon img {
    width: 50px;
    height: 50px;
}

.widgetIcon-32 img {
    width: 32px;
    height: 32px;
}

.sec2Charts .titlebg {
    font-size: 1.1em;
    color: #000;
    font-weight: 500;
    margin-bottom: 10px;
    text-align: left;
}

.titlebg {
    font-size: 1.2em;
    color: #000;
    font-weight: 500;
    margin-bottom: 10px;
    text-align: center;
}

.chart3Title {
    font-size: 1.2em;
    color: #000;
    font-weight: 500;
    text-align: left;
}

.chartbox {
    background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
    color: #353535;
    /* font-size: 14px; */
}

.chartbox3 {
    background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
    color: #353535;
    /* min-height: 495px; */
}

h5,
.h5 {
    font-size: 1.1rem !important;
}

p {
    line-height: 1rem !important;
}

small,
.small {
    font-size: 80% !important;
}

table tr td {
    font-size: 0.8em;
}

.accordion-button {
    font-size: 0.5em;
}

.accordion-button:not(.collapsed) {
    background-color: #e0e0e0;
    color: #222;
}

.filterForm>.form-label {
    font-size: 0.825em;
}

.form-label {
    font-size: 0.825em;
}

.Headfont {
    font-size: 1.8rem;
}

.dropdown-menu[data-bs-popper] {
    right: 0 !important;
    left: auto;
}

/***************************** PageTwo *******************************/
.bt-graph {
    border-right: solid 1px #b5b5b5;
}

.icon-rgt {
    /* width: 62%; */
    float: right;
}

.icon-rgt-top {
    font-size: 13px;
    width: 100%;
    padding: 5px 0px 2px 0px;
}

.fst1 {
    border-left: solid 2px #ffa650;
    float: right;
    margin-right: 10px;
    padding-left: 5px;
    font-size: 11px;
}

/* .icon-rgt-top {} */

.fst {
    border-left: solid 2px #ffa650;
    padding-left: 5px;
    /* font-size: 11px; */
    font-size: 12px;
}



/* media queries start here */

@media screen and (max-width: 991px) {
    .mgt-2 {
        margin-top: 20px;
    }
}

@media screen and (max-width: 740px) {
    .titlebg {
        font-size: 0.9em;
    }
}

@media screen and (max-width: 720px) {
    .mainDiv {
        margin-top: 124px;
    }
}

@media screen and (max-width: 480px) {
    .mainDiv {
        margin-top: 155px;
    }
}

@media screen and (max-width: 480px) {
    .topHeader h2 {
        font-size: 22px;
        padding-right: 3rem;
    }

    .titlebg {
        font-size: 0.9em;
    }
}

@media screen and (max-width: 320px) {
    .topHeader h2 {
        font-size: 16px;
        padding-right: 0rem;
    }
}

.boxHead_bus {
    background: #CDDAEA;
    border-bottom: 1px solid #358696;
    padding: 5px;
    height: 30px;
    /* margin-bottom: 15px; */
    margin-top: 5px;
}

dl dt {
    display: inline-block;
    width: 5px;
    height: 15px;
    vertical-align: middle;
}

dl dd {
    display: inline-block;
    margin: 0px 5px;
    padding-bottom: 0;
    vertical-align: middle;
    font-size: 12px;
}

dl dt.red {
    background: #ffa344;
}

dl dt.yellow {
    background: #358696;
}

/* #chartdivBCS{
    width: 100%;
    height: 500px;
} */
.evfpr0{
    padding-right: 0px;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Orion/Faultanalysis_Orion/FaultSecondPage_Orion/FaultSecondPageCustom_Orion.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;;;;;;;;IASI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,uCAAuC;IACvC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,+CAA+C;AACnD;;AAEA,iBAAiB;AACjB;;IAEI,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,cAAc;IACd,mDAAmD;IACnD,yDAAyD;AAC7D;;AAEA,qBAAqB;;AAErB;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,cAAc;IACd,uBAAuB;AAC3B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA,sEAAsE;AACtE;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA,qBAAqB;;AAErB;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;AACnB;;;;AAIA,6BAA6B;;AAE7B;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;GAGG;AACH;IACI,kBAAkB;AACtB","sourcesContent":[".btn-outline-primary {\n    color: #358696;\n    border-color: #358696;\n}\n\n.btn-outline-primary:hover,\n.btn-outline-primary:focus,\n.btn-outline-primary:visited,\n.btn-outline-primary:active,\n.btn-check:checked+.btn,\n.btn.active,\n.btn.show,\n.btn:first-child:active,\n:not(.btn-check)+.btn:active {\n    background-color: #358696;\n    color: #fff;\n}\n\n.btn:hover {\n    color: var(--bs-btn-hover-color);\n    background-color: #358696;\n    border-color: #358696;\n}\n\n.btn-primary {\n    --bs-btn-color: #fff;\n    --bs-btn-bg: #358696;\n    --bs-btn-border-color: #358696;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #358696;\n    --bs-btn-hover-border-color: #358696;\n    --bs-btn-focus-shadow-rgb: 49, 132, 253;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #358696;\n    --bs-btn-active-border-color: #358696;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #fff;\n    --bs-btn-disabled-bg: #358696;\n    --bs-btn-disabled-border-color: #358696;\n}\n\n.form-check-input:checked {\n    background-color: #358696;\n    border-color: #358696;\n}\n\n.form-select:focus {\n    border-color: #358696;\n    outline: 0;\n    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 23%);\n}\n\n/* Tabs Section */\n.nav-link:focus,\n.nav-link:hover {\n    /* color: var(--bs-nav-link-hover-color); */\n    color: #358696;\n}\n\n.nav-link {\n    color: #999;\n}\n\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link.active {\n    color: #358696;\n    background-color: var(--bs-nav-tabs-link-active-bg);\n    border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n\n/* Section Header<> */\n\n.secHead34 {\n    background-color: #d3eff4;\n    padding: 10px;\n    margin-bottom: 20px;\n}\n\n.bg-white {\n    background-color: #fff;\n}\n\n.headBG {\n    box-sizing: border-box;\n    background: #FFFFFF;\n    border: 1px solid #358696;\n}\n\n.mainDiv {\n    margin-top: 80px;\n}\n\n.widget_bus {\n    background: #CDDAEA;\n    box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\n}\n\n.widgetIcon img {\n    width: 50px;\n    height: 50px;\n}\n\n.widgetIcon-32 img {\n    width: 32px;\n    height: 32px;\n}\n\n.sec2Charts .titlebg {\n    font-size: 1.1em;\n    color: #000;\n    font-weight: 500;\n    margin-bottom: 10px;\n    text-align: left;\n}\n\n.titlebg {\n    font-size: 1.2em;\n    color: #000;\n    font-weight: 500;\n    margin-bottom: 10px;\n    text-align: center;\n}\n\n.chart3Title {\n    font-size: 1.2em;\n    color: #000;\n    font-weight: 500;\n    text-align: left;\n}\n\n.chartbox {\n    background: #FFFFFF;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    padding: 10px;\n    color: #353535;\n    /* font-size: 14px; */\n}\n\n.chartbox3 {\n    background: #FFFFFF;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    padding: 10px;\n    color: #353535;\n    /* min-height: 495px; */\n}\n\nh5,\n.h5 {\n    font-size: 1.1rem !important;\n}\n\np {\n    line-height: 1rem !important;\n}\n\nsmall,\n.small {\n    font-size: 80% !important;\n}\n\ntable tr td {\n    font-size: 0.8em;\n}\n\n.accordion-button {\n    font-size: 0.5em;\n}\n\n.accordion-button:not(.collapsed) {\n    background-color: #e0e0e0;\n    color: #222;\n}\n\n.filterForm>.form-label {\n    font-size: 0.825em;\n}\n\n.form-label {\n    font-size: 0.825em;\n}\n\n.Headfont {\n    font-size: 1.8rem;\n}\n\n.dropdown-menu[data-bs-popper] {\n    right: 0 !important;\n    left: auto;\n}\n\n/***************************** PageTwo *******************************/\n.bt-graph {\n    border-right: solid 1px #b5b5b5;\n}\n\n.icon-rgt {\n    /* width: 62%; */\n    float: right;\n}\n\n.icon-rgt-top {\n    font-size: 13px;\n    width: 100%;\n    padding: 5px 0px 2px 0px;\n}\n\n.fst1 {\n    border-left: solid 2px #ffa650;\n    float: right;\n    margin-right: 10px;\n    padding-left: 5px;\n    font-size: 11px;\n}\n\n/* .icon-rgt-top {} */\n\n.fst {\n    border-left: solid 2px #ffa650;\n    padding-left: 5px;\n    /* font-size: 11px; */\n    font-size: 12px;\n}\n\n\n\n/* media queries start here */\n\n@media screen and (max-width: 991px) {\n    .mgt-2 {\n        margin-top: 20px;\n    }\n}\n\n@media screen and (max-width: 740px) {\n    .titlebg {\n        font-size: 0.9em;\n    }\n}\n\n@media screen and (max-width: 720px) {\n    .mainDiv {\n        margin-top: 124px;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .mainDiv {\n        margin-top: 155px;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .topHeader h2 {\n        font-size: 22px;\n        padding-right: 3rem;\n    }\n\n    .titlebg {\n        font-size: 0.9em;\n    }\n}\n\n@media screen and (max-width: 320px) {\n    .topHeader h2 {\n        font-size: 16px;\n        padding-right: 0rem;\n    }\n}\n\n.boxHead_bus {\n    background: #CDDAEA;\n    border-bottom: 1px solid #358696;\n    padding: 5px;\n    height: 30px;\n    /* margin-bottom: 15px; */\n    margin-top: 5px;\n}\n\ndl dt {\n    display: inline-block;\n    width: 5px;\n    height: 15px;\n    vertical-align: middle;\n}\n\ndl dd {\n    display: inline-block;\n    margin: 0px 5px;\n    padding-bottom: 0;\n    vertical-align: middle;\n    font-size: 12px;\n}\n\ndl dt.red {\n    background: #ffa344;\n}\n\ndl dt.yellow {\n    background: #358696;\n}\n\n/* #chartdivBCS{\n    width: 100%;\n    height: 500px;\n} */\n.evfpr0{\n    padding-right: 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
